export const MAX_UPLOAD_IMAGE_SIZE_MB = 6;
export const MIN_NUMBER_IMAGES_UPLOAD_FREE = 4;
export const MAX_NUMBER_IMAGES_UPLOAD_FREE = 12;

export const MAX_UPLOAD_IMAGE_SIZE_BYTES = 3000000;

